import React from 'react';
import {Table, Image, Space, Flex, Form, Modal, Input, message, Radio, Alert} from 'antd';
import dayjs from 'dayjs';
import usePagination from '../../../components/pagination';

export default () => {
    const [dataSource, setDataSource] = React.useState([]);
    const [refuseForm] = Form.useForm();
    const [agreeForm] = Form.useForm();
    const { pagination, setTotal } = usePagination({
        onChange: (page, pageSize) => {
            getJoinList(page, pageSize).then((res) => {
                setDataSource(res.rows);
                setTotal(res.count);
            });
        },
    });
    const typeMap = {
        1: '个人',
        2: '公司',
        3: '个体户'
    }
    const statusMap = {
        0: '注册中',
        1: '待审核',
        2: '生效',
        3: '禁用'
    }

    React.useEffect(() => {
        getJoinList().then((res) => {
            setDataSource(res.rows);
            setTotal(res.count);
        });
    }, [])
    const getJoinList = async (page = 1, pageSize = 10) => {
        const response = await fetch(`/api/sys/join/list?page=${page}&pageSize=${pageSize}`);
        const result = await response.json();

        if (result && result.success) {
            return result.data;
        }else{
            return [];
        }
    }

    const refuse = async (accId) => {
        Modal.confirm({
            icon: null,
            title: '拒绝申请',
            content: <Form form={refuseForm}>
                <Form.Item name='remark' rules={[{ required: true, message: '请输入拒绝原因' }]}>
                    <Input placeholder='请输入拒绝原因' />
                </Form.Item>
            </Form>,
            onOk: async () => {
                const values = await refuseForm.validateFields();

                const response = await fetch(`/api/sys/join/refuse?accId=${accId}`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        remark: values.remark
                    })
                });
                const result = await response.json();

                if (result && result.success) {
                    message.success('操作成功');
                    setTimeout(() => {
                        getJoinList().then((res) => {
                            setDataSource(res.rows);
                        });
                    }, 500);
                } else {
                    message.error(result.data);
                }
            }
        })
    }

    const agree = async (accId) => {
        Modal.confirm({
            icon: null,
            title: '审核通过',
            content: 
                <div>
                    <Alert message='请选择版本' type='warning' />
                    <Form form={agreeForm}>
                        <Form.Item name='versionId' rules={[{ required: true, message: '请输入拒绝原因' }]}>
                            <Radio.Group>
                                <Radio value={1}>基础本(免费)</Radio>
                                <Radio value={2}>专业版</Radio>
                                <Radio value={3}>连锁版</Radio>
                            </Radio.Group>
                        </Form.Item>
                    </Form>
                </div>,
            onOk: async () => {
                const values = await agreeForm.validateFields();

                const response = await fetch(`/api/sys/join/agree?accId=${accId}`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        versionId: values.versionId
                    })
                });
                const result = await response.json();

                if (result && result.success) {
                    message.success('操作成功');
                    setTimeout(() => {
                        getJoinList().then((res) => {
                            setDataSource(res.rows);
                        });
                    }, 500);
                } else {
                    message.error(result.data);
                }
            }
        })
    }

    const showMiniProgramLink = async (accId) => {
        try {
            const response = await fetch(`/api/wxopen/wx-mini-page-url`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    accId,
                    path: 'pages/index/index',
                    params: {}
                })
            });
            const result = await response.json();

            if (result?.success) {
                const urlLink = result.data.url_link;
                Modal.info({
                    title: '小程序链接',
                    icon: null,
                    width: 400,
                    content: (
                        <div style={{textAlign: 'center'}}>
                            <p>扫码进入小程序</p>
                            <img 
                                src={`https://api.qrserver.com/v1/create-qr-code/?size=200x200&data=${encodeURIComponent(urlLink)}`} 
                                alt="小程序二维码"
                                style={{width: '200px', height: '200px'}}
                            />
                            <div style={{marginTop: '16px', wordBreak: 'break-all'}}>
                                <a href={urlLink} target="_blank" rel="noopener noreferrer">{urlLink}</a>
                            </div>
                        </div>
                    )
                });
            } else {
                message.error('获取小程序链接失败！');
            }
        } catch (error) {
            console.error('获取小程序链接失败:', error);
            message.error('获取小程序链接失败！');
        }
    }

    const columns = [
        {
            title: '账户ID',
            dataIndex: 'accId',
        },
        {
            title: '账户类型',
            dataIndex: 'type',
            render: (text) => {
                return typeMap[text]
            }
        },
        {
            title: '状态',
            dataIndex: 'status',
            render: (text) => {
                return <span style={{color: text === 1 ? 'red' : ''}}>{statusMap[+text]}</span>
            }
        },
        {
            title: '注册日期',
            dataIndex: 'createTime',
            render: (text) => {
                return <span>{dayjs(text).format('YYYY-MM-DD HH:mm')}</span>
            }
        },
        {
            title: '电话',
            dataIndex: 'phoneNo',
        },
        {
            title: '姓名(法人)',
            dataIndex: 'realname',
        },
        {
            title: '身份证号',
            dataIndex: 'idNo',
        }
        ,
        {
            title: '身份证图片',
            dataIndex: 'idUrl',
            render: (text, record) => {
                return <Flex gap={5}>
                    <Image src={`${text}?x-oss-process=image/resize,w_200`} style={{ width: '60px' }} preview={{
                        src: text,
                    }} />
                    <Image src={`${record.idUrl2}?x-oss-process=image/resize,w_200`} style={{ width: '60px' }}  preview={{
                        src: record.idUrl2,
                    }} />
                </Flex>
            }
        },
        {
            title: '公司名称',
            dataIndex: 'companyName',
        },
        {
            title: '信用代码',
            dataIndex: 'companyId',
        },
        {
            title: '营业执照图片',
            dataIndex: 'companyIdUrl',
            render: (text) => {
                return <div>
                    {text && <Image src={`${text}?x-oss-process=image/resize,w_200`} style={{ width: '60px' }} preview={{
                        src: text,
                    }} />}
                </div>
            }
        },
        {
            title: '操作',
            dataIndex: 'status',
            fixed: 'right',
            render: (text, record) => {
                return <Space>
                    {
                        text === 1 && <>
                            <a onClick={() => agree(record.accId)}>通过</a>
                            <a onClick={() => refuse(record.accId)}>拒绝</a>
                        </>
                    }
                    <a onClick={() => showMiniProgramLink(record.accId)}>小程序链接</a>
                </Space>
            }
        },

    ]
    return (
        <div>
            <h1>审核列表</h1>
            <Table rowKey={'accId'} columns={columns} dataSource={dataSource} scroll={{ x: 'max-content' }} pagination={pagination} />
        </div>
    )
}